import React from 'react';

import cs from 'classnames';
import {CircularProgressbarWithChildren} from 'react-circular-progressbar';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import 'react-circular-progressbar/dist/styles.css';
import {simpleGetProgressLabel} from 'app/tasks/utils';

import {StyledCircleProgressbarDiv} from './TasksDashboard/StyledComponents';

import type {SlimTaskInstanceSerializedType} from 'sweet-types';

export function PercentageBadge({
  task,
  isOverdue,
  size,
}: {
  task: SlimTaskInstanceSerializedType;
  isOverdue: boolean;
  size: string;
}): JSX.Element {
  const {style, text} = simpleGetProgressLabel(task);
  return (
    <LazyTooltip tooltip={text}>
      <StyledCircleProgressbarDiv status={style} size={size}>
        <CircularProgressbarWithChildren
          value={task.progress_percent ?? 0}
          strokeWidth={12}
        >
          <small
            className={cs('font-weight-bold', {'text-danger': isOverdue})}
          >{`${task.progress_percent ?? 0}%`}</small>
        </CircularProgressbarWithChildren>
      </StyledCircleProgressbarDiv>
    </LazyTooltip>
  );
}
